<template>
  <div id="tablesWrapper">

    <div class="columns">
      <div class="column is-fullwidth">
        <aside class="menu">

          <ul class="menu-list">
            <li v-for="table in visibleTables" :key="table.id">
              <router-link :to="{ path: `tabellen/${table.id}` }">{{ table.name }}</router-link>
            </li>
          </ul>

        </aside>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      name: null,
      selected: 0,
      checked: []
    }
  },
  computed: {
    ...mapGetters({
      tables: 'tables/tables',
      bundle: 'bundles/bundle',
      columns: 'columns/columns'
    }),
    visibleTables () {
      return this.tables.filter(table => !this.bundle.has_disabled['tables'].includes(table.id))
    }
  }
}
</script>
